// @ts-strict-ignore
import LocalizedLink from '@components/Localization/LocalizedLink'
import { Image } from '@components/gassan-ui'
import { StyledLink } from '@components/gassan-ui/StyledLink'
import { useBreakpoint } from '@lib/hooks/useBreakpoint'
import { imgix } from '@lib/imigx'
import * as Elements from '@lib/kontent/models/Elements'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { breakpoints } from '@components/gassan-ui/theme'
import { cn } from '@lib/cn'

type ProductSliderFeaturedImageProps = {
  featuredImageLink?: Elements.TextElement
  featuredImage?: Elements.AssetsElement
}

export const ProductSliderFeaturedImage: FC<ProductSliderFeaturedImageProps> = ({
  featuredImage,
  featuredImageLink,
}) => {
  const { t } = useTranslation('other')
  const isMediumUp = useBreakpoint(breakpoints.medium)

  return (
    <div className="flex w-full">
      <div
        className={cn(
          'relative h-[calc(100%-60px)] w-full overflow-hidden',
          'sm:h-[calc(100%-76px)]',
          'lg:h-[calc(100%-76px)]',
        )}
      >
        <Image
          className="aspect-[5/7] h-full"
          sources={[imgix(featuredImage.value[0].url, { width: 600 })]}
          alt="Featured image"
        />
        {featuredImageLink.value && (
          <LocalizedLink href={`/${featuredImageLink.value}`} passHref>
            <a
              className={cn(
                'group absolute left-0 top-0 z-[2] flex h-full w-full items-end p-4 text-white',
                'bg-gradient-to-b from-[rgba(20,20,20,0)] to-[rgba(20,20,20,0.6)]',
                'lg:p-6',
              )}
            >
              <div className="absolute inset-0 z-0 hidden bg-gradient-to-b from-[rgba(20,20,20,0)] to-[rgba(20,20,20,0.6)] transition-opacity duration-200" />
              <StyledLink className="z-[3] text-white" variant="grey">
                {isMediumUp ? t('viewAll') : t('view')}
              </StyledLink>
            </a>
          </LocalizedLink>
        )}
      </div>
      <div className="h-full w-4"></div>
    </div>
  )
}
